export type VehicleLabelDisplay = {
  widthCm?: number;
  heightCm?: number;
  logo: boolean;
  qr: boolean;
  vrm: boolean;
  makeModel: boolean;
  stockNumber: boolean;
  vin: boolean;
  engineCode: boolean;
  fuelType: boolean;
  colour: boolean;
  mileage: boolean;
};

export const defaultVehicleLabelDisplay: VehicleLabelDisplay = {
  widthCm: 10,
  heightCm: 5,
  logo: true,
  qr: true,
  vrm: true,
  makeModel: true,
  stockNumber: true,
  vin: true,
  engineCode: true,
  fuelType: true,
  colour: true,
  mileage: true,
};
